var React = require('react');

function PropertySnowbirdWings (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",null,[React.createElement("path",{"d":"m33.75,20.32l.04.05-15.26,16.51-.04.03h-.02v-9.93c0-.8.23-2.09.91-3.27.38-.66.93-1.23,1.53-1.77,1.24-1.1,2.98-1.59,4.52-1.63h8.32Z","key":0}),React.createElement("path",{"d":"m1.22,20.32v.05l15.24,16.53h.04v-9.91c0-.8-.23-2.09-.91-3.27-.28-.49-.65-.94-1.07-1.36-.15-.14-.31-.27-.46-.41-1.24-1.1-2.98-1.59-4.52-1.63,0,0-8.32,0-8.32,0Z","key":1})])));
}

PropertySnowbirdWings.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 33.79 36.91"};

module.exports = PropertySnowbirdWings;

PropertySnowbirdWings.default = PropertySnowbirdWings;
